<template>
  <div style="width: 100%; height: 100%;">
    <pc-home v-if="pcShow" class="pc-div"/>
    <mobile-home v-if="mobileShow" class="mobile-div"/>
  </div>
</template>

<script>

  import PcHome from "../../components/PcHome";
  import MobileHome from "../../components/mobile/MobileHome";
  import { debounce } from '@/utils/index'

  export default {
    name: 'Home',
    components: {
      MobileHome,
      PcHome
    },
    data() {
      return {
        width: 1024,
        pcShow: false,
        mobileShow: false,
      }
    },
    computed: {
    },
    beforeMount() {
      window.addEventListener('resize', debounce(this.resizeHandler, 100));
    },
    mounted() {
      this.resizeHandler();
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.resizeHandler);
    },
    methods: {
      isMobile() {
        const { body } = document;
        const rect = body.getBoundingClientRect();
        return rect.width < this.width;
      },
      resizeHandler(e) {
        const isMobile = this.isMobile();
        if (isMobile) {
          this.pcShow = false;
          this.mobileShow = true;
        } else {
          this.pcShow = true;
          this.mobileShow = false;
        }
      },
    },
  }
</script>


<style scoped lang="scss">

</style>
